import { useEffect } from "react";

/**
 * Tiny document-head manager (no react-helmet dep).
 * Sets title, meta description, and canonical for a route. Restores on unmount.
 */
const setMeta = (name, content, isProperty = false) => {
  if (!content) return null;
  const attr = isProperty ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  const prev = el?.getAttribute("content") || null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  return { el, prev };
};

const setCanonical = (href) => {
  if (!href) return null;
  let el = document.head.querySelector('link[rel="canonical"]');
  const prev = el?.getAttribute("href") || null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
  return { el, prev };
};

const useSeo = ({ title, description, canonical, ogTitle, ogDescription }) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    const undo = [];
    if (description) undo.push(setMeta("description", description));
    if (ogTitle) undo.push(setMeta("og:title", ogTitle, true));
    if (ogDescription) undo.push(setMeta("og:description", ogDescription, true));
    if (canonical) undo.push(setCanonical(canonical));

    return () => {
      document.title = prevTitle;
      undo.forEach((entry) => {
        if (!entry) return;
        if (entry.prev === null) entry.el.remove();
        else if (entry.el.tagName === "META")
          entry.el.setAttribute("content", entry.prev);
        else entry.el.setAttribute("href", entry.prev);
      });
    };
  }, [title, description, canonical, ogTitle, ogDescription]);
};

export default useSeo;
